import styled from 'styled-components';

export const Box = styled.div`
  padding: 15px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  border-top: 1px solid ${({ theme }) => theme.palette.primary.border};
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  margin-top: 10px;
`;
